import React from 'react';
import styled from 'styled-components';
import ContactSection from '../components/ContactSection';

const ContactContainer = styled.div`
  padding-top: 120px;
`;

const HeroSection = styled.section`
  background: linear-gradient(135deg, var(--primary-color) 0%, #e67e00 100%);
  color: var(--white-color);
  padding: 100px 0;
  text-align: center;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ContactPage = () => {
  return (
    <ContactContainer>
      <HeroSection>
        <Container>
          <HeroTitle>İletişim</HeroTitle>
          <HeroSubtitle>
            Bizimle iletişime geçin. Size en kısa sürede dönüş yapacağız.
          </HeroSubtitle>
        </Container>
      </HeroSection>
      
      <ContactSection />
    </ContactContainer>
  );
};

export default ContactPage; 